import {
    differenceInCalendarDays,
    differenceInHours,
    differenceInMinutes,
    differenceInSeconds,
    format,
    isSameMonth,
    isSameYear,
    parseISO,
} from "date-fns";

import { formatDate } from "@/utils";

/** Name the date section a time falls under, counting calendar days in the local time zone. */
export function groupLabel(iso: string, now: Date): string {
    const date = parseISO(iso);
    const daysAgo = differenceInCalendarDays(now, date);
    if (daysAgo <= 0) return "Today";
    if (daysAgo === 1) return "Yesterday";
    if (daysAgo <= 7) return "Previous 7 days";
    if (isSameMonth(date, now)) return `Earlier in ${format(now, "MMMM")}`;
    return format(date, isSameYear(date, now) ? "MMMM" : "MMMM yyyy");
}

export function rowTimestamp(iso: string, now: Date): string {
    const date = parseISO(iso);
    if (differenceInSeconds(now, date) < 60) return "Just now";
    const daysAgo = differenceInCalendarDays(now, date);
    if (daysAgo === 0) {
        const minutes = differenceInMinutes(now, date);
        return minutes < 60
            ? `${minutes} min ago`
            : `${differenceInHours(now, date)} hr ago`;
    }
    if (daysAgo === 1) return format(date, "'Yesterday', h:mm a");
    if (daysAgo <= 6) return format(date, "EEE, MMM d");
    return format(date, isSameYear(date, now) ? "MMM d" : "MMM d, yyyy");
}

export function absoluteTime(iso: string): string {
    return formatDate(iso, "PPp");
}
